import type { User } from '@ifixit/auth-sdk';

export const WORKBENCH_PATH = '/go/workbench';

// The user API gives us team ids, not names, so the beta list is ids with the
// team name alongside each one.
const BETA_TEAM_IDS: ReadonlySet<number> = new Set([
   51991, // iFixit Beta Group
   19884, // Greybeards
   696, // Global Fixers
   271, // Master Techs
   46701, // German Translators
]);

export type WorkbenchUser = Pick<
   User,
   'isAdmin' | 'isAuthor' | 'isEmployee' | 'isModerator' | 'teams'
>;

export function canAccessWorkbench(user: WorkbenchUser): boolean {
   return (
      user.isEmployee ||
      user.isAdmin ||
      user.isModerator ||
      user.isAuthor ||
      user.teams.some(teamid => BETA_TEAM_IDS.has(teamid))
   );
}
